import React from 'react'
import "./fotter.css"

function Fotter() {
  return (
    <div>
         <div>
      <div className="footer-div">
        <p className="footer-text">
          Made with ❤️ by Aditi Bhosale
        </p>
      </div>
    </div>

    </div>
  )
}

export default Fotter